/**
 * Shared "is this list empty" logic for list pages that show a dedicated
 * empty-state card. Distinguishes a genuinely empty dataset (`isTrueEmpty`)
 * from a search/filter that just happens to return zero rows (`isEmpty`
 * but not `isTrueEmpty`) so callers can hide the toolbar only in the former
 * case and avoid trapping the user with a hidden search box in the latter.
 *
 * `count` should be the dataset's total count (e.g. `metaData.count`), not
 * the current page's row count — otherwise a retained page number that's
 * out of range for the active tab/filter reads as a genuinely empty
 * dataset and hides pagination along with it.
 *
 * `isError` should reflect the backing query's error state: on a failed
 * request `isLoading` becomes `false` and `count` is typically `0`, which
 * would otherwise be indistinguishable from a real empty dataset and hide
 * the retry (refresh) action along with the rest of the toolbar.
 */
export function useListEmptyState(
  isLoading: boolean,
  count: number,
  hasActiveFilters: boolean,
  isError = false,
) {
  const isEmpty = !isLoading && !isError && count === 0;
  return { isEmpty, isTrueEmpty: isEmpty && !hasActiveFilters };
}
